import angular from 'angular';

import { PublicLinkComponent } from './components/publicLink.component';
import { PublicIdService } from './services/publicId.service';
import { PublicLinkService } from './services/publicLink.service';

const publicLink = angular.module('publicLink', []);

publicLink.component('publicLink', PublicLinkComponent);

publicLink.service('PublicIdService', PublicIdService);
publicLink.service('PublicLink', PublicLinkService);

export const PublicLinkModule = publicLink;